module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm-552eb1a2aa8a96c36315682523c26a4d.png";